import videojs from "video.js";
import "video.js/dist/video-js.css";
export default {
  data() {
    return {
      player: null
    };
  },
  mounted() {
    let that = this;
    this.initVideoWH();
    // this.initVideoWH()
    this.player = videojs(this.$refs.video, {
      sources: [{
        type: "application/x-mpegURL",
        src: JSON.parse(localStorage.getItem("plotInfo")).monitorList.length == 0 ? '' : JSON.parse(localStorage.getItem("plotInfo")).monitorList[0].url
      }],
      autoplay: true,
      controlBar: {
        // 设置控制条组件
        // 设置控制条里面组件的相关属性及显示与否
        currentTimeDisplay: true,
        timeDivider: true,
        durationDisplay: true,
        remainingTimeDisplay: false,
        volumePanel: {
          inline: false
        },
        /* 使用children的形式可以控制每一个控件的位置，以及显示与否 */
        children: [{
          name: "playToggle"
        },
        // 播放按钮
        // { name: "currentTimeDisplay" }, // 当前已播放时间
        // { name: "progressControl" }, // 播放进度条
        // { name: "durationDisplay" }, // 总时间
        {
          // 倍数播放
          name: "playbackRateMenuButton",
          playbackRates: [0.5, 1, 1.5, 2, 2.5]
        }, {
          name: "volumePanel",
          // 音量控制
          inline: false // 不使用水平方式
        }, {
          name: "FullscreenToggle"
        } // 全屏
        ]
      }
    });
  },

  methods: {
    initChart() {},
    initVideoWH() {
      let content = this.$refs.content;
      this.videoWidth = content.clientWidth + "px";
      this.videoHeight = content.clientHeight + "px";
      console.log(this.videoWidth, this.videoHeight, "vidfeo");
    },
    destroyed() {
      if (this.player) {
        this.player.dispose();
      }
    }
  },
  destroyed() {
    console.log('销毁');
  }
};